"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgAnalytics = function SvgAnalytics(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 110 100",
    fill: "none"
  }, props), {}, {
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M88.579 70.454H29.27a8.065 8.065 0 01-8.065-8.065V31.03a4.838 4.838 0 014.839-4.838h62.534a4.84 4.84 0 014.839 4.839v34.585a4.84 4.84 0 01-4.84 4.839",
      fill: "#EDE6FF"
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M59.83 34.789l9.672 7.093-8.365 4.83L59.83 34.79zM65.755 45.052l2.44 4.226",
      stroke: "#6542BE",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.349 66.939H4.336a1.612 1.612 0 110-3.226h7.013c.892 0 1.612.72 1.612 1.613 0 .892-.72 1.613-1.612 1.613M68.57 99.636h-7.012a1.613 1.613 0 110-3.225h7.012a1.611 1.611 0 110 3.226",
      fill: "#EDE6FF"
    }), (0, _jsxRuntime.jsx)("mask", {
      id: "analytics_svg__a",
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 69,
      width: 11,
      height: 4,
      children: (0, _jsxRuntime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 69.161h10.237v3.226H0V69.16z",
        fill: "#fff"
      })
    }), (0, _jsxRuntime.jsx)("g", {
      mask: "url(#analytics_svg__a)",
      children: (0, _jsxRuntime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.624 72.387H1.612a1.612 1.612 0 110-3.226h7.012c.892 0 1.613.721 1.613 1.613s-.721 1.613-1.613 1.613",
        fill: "#EDE6FF"
      })
    }), (0, _jsxRuntime.jsx)("mask", {
      id: "analytics_svg__b",
      maskUnits: "userSpaceOnUse",
      x: 96,
      y: 1,
      width: 13,
      height: 13,
      children: (0, _jsxRuntime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M96.474 1.614h11.8v11.798h-11.8V1.614z",
        fill: "#fff"
      })
    }), (0, _jsxRuntime.jsx)("g", {
      mask: "url(#analytics_svg__b)",
      children: (0, _jsxRuntime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M106.661 5.9h-2.674V3.226c0-.892-.721-1.613-1.613-1.613s-1.613.721-1.613 1.613V5.9h-2.674c-.892 0-1.613.721-1.613 1.613s.721 1.613 1.613 1.613h2.674V11.8c0 .892.721 1.613 1.613 1.613s1.613-.721 1.613-1.613V9.126h2.674c.892 0 1.613-.72 1.613-1.613 0-.892-.721-1.613-1.613-1.613",
        fill: "#EDE6FF"
      })
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M95.123 65.242H33.15a6.739 6.739 0 01-6.732-6.731V24.485a6.74 6.74 0 016.732-6.732h9.71a1.614 1.614 0 010 3.226h-9.71a3.511 3.511 0 00-3.506 3.506v34.026a3.51 3.51 0 003.506 3.505h61.974a3.51 3.51 0 003.505-3.505V24.485a3.51 3.51 0 00-3.505-3.506h-42.93a1.612 1.612 0 110-3.226h42.93c3.712 0 6.731 3.02 6.731 6.732v34.026c0 3.711-3.02 6.73-6.73 6.73M76.933 76.59H51.34a1.612 1.612 0 110-3.226h25.592a1.612 1.612 0 110 3.226",
      fill: "#6542BE"
    })]
  }));
};

var _default = SvgAnalytics;
exports["default"] = _default;